import { V1Api } from "./v1";
const basePath = window.location.origin;
const api = new V1Api(undefined, basePath);
export { api };
